import soundStore from 'src/stores/sound_store';
import { getLongLangCode } from 'src/utils/language_code';

export const SOUND_OPTIONS = [1, 2, 3];

let player = null;

export const playSoundFile = (name) => {
  if (player) player.pause();
  player = new Audio(`/assets/sounds/${name}.wav`);
  player.play().catch(() => {});
};

export const playSuccessSound = () => {
  const { soundOn, successSound } = soundStore.getState();
  if (!soundOn) return;
  playSoundFile(`success_${successSound}`);
};

export const playFailSound = () => {
  const { soundOn, failSound } = soundStore.getState();
  if (!soundOn) return;
  playSoundFile(`fail_${failSound}`);
};

export const speakText = (text) => {
  const { soundOn } = soundStore.getState();
  if (!soundOn || !text || !window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = getLongLangCode();
  window.speechSynthesis.speak(utterance);
};
